import contentEditable from '../../content-editable';

const documentInputHandler = (e) => {
  contentEditable.helpers.setSelectionOnInput();
  contentEditable.helpers.handleNativeInputBehavior(e);
};

export default documentInputHandler;
